import {ChevronDownIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React, {useState} from 'react';

import {TOC} from '../util/generateTOC';
import Button from './buttons/Button';

export type Props = {
  toc?: TOC;
  className?: string;
  show: number;
};

const TableOfContents = ({className, toc, show}: Props) => {
  const [open, setOpen] = useState(false);

  if (!toc || !toc.length) return null;
  return (
    <div className={classNames('p-xs bg-gray-50 font-medium', className)}>
      <p className={'mb-xs text-lg'}>Table of Contents</p>
      <ul className={'pl-8 [&_a]:text-primary-600'}>
        {toc.slice(0, open ? toc.length : show - 1).map(({level, id, text}) => (
          <li key={id} style={{marginLeft: `${22 * (level - 1)}px`}}>
            <a href={`#${id}`}>{text}</a>
          </li>
        ))}
      </ul>
      {show < toc.length && (
        <Button variant={'link'} onClick={() => setOpen(!open)} className={'!block mt-xs mx-auto !text-xs'}>
          {open ? 'Show less' : 'Show more'}
          <ChevronDownIcon
            className={classNames('inline ml-2 w-5 h-5 transition-transform duration-300', open && '-rotate-180')}
          />
        </Button>
      )}
    </div>
  );
};

export default TableOfContents;
